// Breaks apart words. Used in `./mapEvents`
export default function tokenize(string) {
  return string.split(/\s+/)
}



// WEBPACK FOOTER //
// ./src/tokenize.js